import axios from 'axios';
import { HOPLA_URL } from '../config/config';
import { Speciality } from '../models/Speciality';

export const getSpecialities = async () : Promise<Speciality[]> => {
    return (await axios.get(HOPLA_URL + '/speciality/enabled')).data;
}